import {
  DEFAULT_CHARACTER_EXTRACT_MODEL,
  isKnownLlmModel,
  type LlmModelValue,
} from "./llmModels";

export const BOOK_ANALYSIS_MODEL_METADATA_KEY = "analysisModel";

/** One model per book for Story Craft, summaries, and all entity/character extraction. */
export function getBookAnalysisModel(
  metadata: Record<string, unknown> | null | undefined
): LlmModelValue {
  const value = metadata?.[BOOK_ANALYSIS_MODEL_METADATA_KEY];
  return typeof value === "string" && isKnownLlmModel(value)
    ? value
    : DEFAULT_CHARACTER_EXTRACT_MODEL;
}

export function withBookAnalysisModel(
  metadata: Record<string, unknown>,
  model: LlmModelValue
): Record<string, unknown> {
  return {
    ...metadata,
    [BOOK_ANALYSIS_MODEL_METADATA_KEY]: model,
  };
}
